import React from 'react';

const ISSUE_META = {
    min_gt_max: {
        label: 'min > max',
        bg: '#fde7e7',
        fg: '#b32d2d',
        icon: '🔴',
    },
    min_missing: {
        label: 'min missing',
        bg: '#fff2e0',
        fg: '#a65000',
        icon: '🟠',
    },
    max_missing: {
        label: 'max missing',
        bg: '#fff2e0',
        fg: '#a65000',
        icon: '🟠',
    },
    min_below_fees: {
        label: 'min ≤ fees',
        bg: '#fde7e7',
        fg: '#b32d2d',
        icon: '🔴',
    },
    price_outside_bounds: {
        label: 'price out of bounds',
        bg: '#fff8db',
        fg: '#8a6d00',
        icon: '🟡',
    },
    below_adidas_map: {
        label: 'below Adidas MAP',
        bg: '#fde7e7',
        fg: '#b32d2d',
        icon: '🔴',
    },
};

export default function IssueChip({ code, product }) {
    const meta = ISSUE_META[code];
    if (!meta) return null;
    let label = meta.label;
    if (code === 'min_below_fees' && product?.estimated_fees != null) {
        label = `min ≤ fees ($${Number(product.estimated_fees).toFixed(2)})`;
    }
    if (code === 'below_adidas_map' && product?.adidas_map != null) {
        label = `below Adidas MAP ($${Number(product.adidas_map).toFixed(2)})`;
    }
    return (
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
                padding: '2px 8px',
                borderRadius: 12,
                fontSize: 11,
                fontWeight: 500,
                background: meta.bg,
                color: meta.fg,
                whiteSpace: 'nowrap',
            }}
        >
            <span aria-hidden="true">{meta.icon}</span>
            {label}
        </span>
    );
}
